<div class="textarea-box-component">
  <div class="label-container" [ngClass]="{'gather-style': source == 'gather'}">
    <label class="question-label" [htmlFor]="textBoxId"
           [innerText]="labelText | translate"
           [ngClass]="invalid && !_value ? 'error-color' : 'normal-color'"
           attr.aria-label="{{labelText | translate}}">
    </label>
    <span *ngIf="showRemainingCharacters && textLength > 0" class="remaining-chars" [ngClass]="maxLength-textLength <=25 ? 'error-color' : 'ok-color'">
      {{maxLength-textLength}} characters remaining
    </span>
  </div>
  <textarea
            rows="6"
            [id]="textBoxId"
            [placeholder]="placeholder | translate"
            [name]="name"
            [(ngModel)]="_value"
            [maxLength]="maxLength"
            (change)="propagateText($event)"
            (ngModelChange)="changeEvent($event)"
            [ngClass]="invalid && !_value ? 'input-error' : 'input-normal '"></textarea>
</div>
